import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand-navy" data-id="element-180" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-181" data-mp="3b143x9u7tf3q">
        <h2 id="testimonios" className="font-display text-base font-extrabold uppercase leading-tight text-white sm:text-xl" data-id="element-182" data-mp="36yzeyoepp6nf">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80" data-id="element-183" data-mp="2x0jmah01dpbt">
          De preparar material por separado a tener una estructura mucho más
          organizada.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-184" data-mp="v96ixwdpvphv">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg bg-white p-2.5 text-left text-brand-navy" data-id="element-185" data-mp="qaljw0a7bbv0" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-186" data-mp="m5b4hoxjxuic">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-brand-yellow text-brand-orange" data-id="element-187" data-mp="79lezgt5qz8v" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] italic leading-snug text-slate-800" data-id="element-188" data-mp="zyiwhhpjos0k">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-189" data-mp="q7ejgnjfjh8d">
                <p className="font-display text-[0.75rem] font-extrabold uppercase text-brand-blue" data-id="element-190" data-mp="q4jymuwi7uef">
                  {t.author}
                </p>
                <p className="text-[0.66rem] leading-snug text-slate-600" data-id="element-191" data-mp="1iv1y7ly0rdn3">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-brand-yellow bg-brand-surface p-3" data-id="element-192" data-mp="1xiiu30tozskt">
            <CtaButton href={OFFER_ANCHOR} data-id="element-193" data-mp="1og9lighzi9a2">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-1.5 text-[0.68rem] font-medium text-white/80" data-id="element-194" data-mp="1jj0z23pszj30">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}